// EMI = P × r × (1+r)^n / ((1+r)^n - 1)
export const calcEMI = (principal, annualRate, months) => {
  if (!principal || !annualRate || !months) return { emi: 0, total: 0, interest: 0 };
  const r = annualRate / 12 / 100;
  const n = months;
  const pow = Math.pow(1 + r, n);
  const emi = (principal * r * pow) / (pow - 1);
  const total = emi * n;
  return {
    emi: Math.round(emi),
    total: Math.round(total),
    interest: Math.round(total - principal),
  };
};

export const formatINR = (n) => {
  if (n == null || isNaN(n)) return "₹0";
  return "₹" + Math.round(n).toLocaleString("en-IN");
};

export const formatLakhs = (n) => {
  if (n >= 10000000) return `₹${(n/10000000).toFixed(2)} Cr`;
  if (n >= 100000) return `₹${(n/100000).toFixed(2)} L`;
  return formatINR(n);
};

// SIP future value
export const calcSIP = (monthly, annualRate, years) => {
  const r = annualRate / 12 / 100;
  const n = years * 12;
  const fv = monthly * ((Math.pow(1 + r, n) - 1) / r) * (1 + r);
  const invested = monthly * n;
  return { invested: Math.round(invested), futureValue: Math.round(fv), returns: Math.round(fv - invested) };
};

// FD maturity (quarterly compounding)
export const calcFD = (principal, annualRate, years) => {
  const r = annualRate / 100 / 4;
  const n = years * 4;
  const maturity = principal * Math.pow(1 + r, n);
  return { invested: principal, maturity: Math.round(maturity), interest: Math.round(maturity - principal) };
};

// RD maturity (quarterly compounding approximation)
export const calcRD = (monthly, annualRate, years) => {
  const r = annualRate / 100 / 4;
  const n = years * 4;
  const months = years * 12;
  // Approximation: M = R * [(1+r)^n - 1] / (1 - (1+r)^(-1/3))
  const maturity = monthly * (Math.pow(1 + r, n) - 1) / (1 - Math.pow(1 + r, -1/3));
  const invested = monthly * months;
  return { invested, maturity: Math.round(maturity), interest: Math.round(maturity - invested) };
};

// Old regime simplified
export const calcIncomeTax = (income, regime = "new") => {
  let tax = 0;
  if (regime === "new") {
    const slabs = [
      [300000, 0], [700000, 0.05], [1000000, 0.10], [1200000, 0.15], [1500000, 0.20], [Infinity, 0.30]
    ];
    let prev = 0;
    for (const [limit, rate] of slabs) {
      if (income > limit) { tax += (limit - prev) * rate; prev = limit; }
      else { tax += (income - prev) * rate; break; }
    }
    // rebate up to 7L
    if (income <= 700000) tax = 0;
  } else {
    const slabs = [
      [250000, 0], [500000, 0.05], [1000000, 0.20], [Infinity, 0.30]
    ];
    let prev = 0;
    for (const [limit, rate] of slabs) {
      if (income > limit) { tax += (limit - prev) * rate; prev = limit; }
      else { tax += (income - prev) * rate; break; }
    }
    if (income <= 500000) tax = 0;
  }
  const cess = tax * 0.04;
  return { tax: Math.round(tax), cess: Math.round(cess), total: Math.round(tax + cess) };
};
